export default "__VITE_ASSET__DwEUWBMO__"